'use client';

import { useEffect } from 'react';
import { useStore } from '@/store/store';
import { ddCancelVital, ddStopVital } from '@/utils/datadog';
import { SEARCH_VITALS } from '@/utils/datadog/vitals';

type RecommendedGamesReadySentinelProps = {
    tilesCount: number;
};

export const RecommendedGamesReadySentinel: React.FC<RecommendedGamesReadySentinelProps> = ({ tilesCount }) => {
    const isSearchOpen = useStore((s) => s.search.isSearchOpen);

    useEffect(() => {
        if (!isSearchOpen) {
            return;
        }
        if (tilesCount === 0) {
            ddCancelVital(SEARCH_VITALS.RECOMMENDED_READY);
            return;
        }
        ddStopVital(SEARCH_VITALS.RECOMMENDED_READY, {
            context: { tiles_count: tilesCount }
        });
    }, [isSearchOpen, tilesCount]);

    return null;
};
